import React, { useState, useEffect, useRef, useContext } from "react";
import Loading from "../../../../../components/Loading";
import Link from "next/link";
import { validateDiscountCode } from "../../../../../crud/checkout.crud";
import { errorToaster, handleKeypress, successToaster } from "../../../../../helpers/utils";
import Checkmark from "../Checkmark";
// import moment from "moment";
import moment from "moment-timezone";
import ReadMore from "../../../../../components/ReadMoreText";
import { convertTimezone, removeSpace } from "../../../../../helpers/common";
import { TinyColor } from "@ctrl/tinycolor";
import WidgetContext from "../../../../../contexts/WidgetContext";
import TippyIcon from "../../../../../components/TippyIcon";
import _ from "lodash";

const CouponBox = ({
	eventDetails,
	query,
	isWidget,
	getCouponDetails,
	couponErr,
	setCouponErr,
	removeCoupon,
	ticketDetails,
	waitlistDetails,
	disabled,
	disabledContent,
	setFormRules,
	isEventPageTeamComp,
	selectedTickets
}) => {
	const [couponCode, setCouponCode] = useState("");
	const [couponValidated, setCouponValidated] = useState(false);
	const [hasCouponCode, setHasCouponCode] = useState(false);
	const [pasted, setPasted] = useState(false);
	const [noRemove, setNoRemove] = useState(false);
	const [discountError, setDiscountError] = useState(false)
	const hasMountedOnce = useRef(false);
	const waitlistMountedOnce = useRef(false);
	const {
		setAccessCodeStatus,
		accessCodeStatus,
		curComp,
		setCurComp,
		setPickedTickets,
		isWaitlist,
		setCouponLoading,
		couponLoading
	} = useContext(WidgetContext);

	const couponRegex = /^[a-zA-Z0-9@&#$!()*-]+$/;

	useEffect(() => {
		if (
			waitlistDetails[0]?.coupon_code !== null &&
			waitlistDetails[0]?.coupon_code !== undefined &&
			waitlistDetails[0]?.coupon_code !== "" &&
			!waitlistMountedOnce.current
		) {
			setCouponCode(waitlistDetails[0].coupon_code);
			setHasCouponCode(true);
			setNoRemove(true);
			validateCoupon(waitlistDetails[0].coupon_code);
			setCouponValidated(true);
			waitlistMountedOnce.current = true;
		}
	}, [waitlistDetails]);

	useEffect(() => {
		if (!couponErr && hasCouponCode) {
			successToaster("Coupon code applied.");
		} else if (couponErr) {
			const isAccessCode = accessCodeStatus == 1 ? true : false;
			errorToaster(couponErr);
			resetCoupon();
			removeCoupon(isAccessCode);
			setCouponErr("");
		}
	}, [couponErr]);

	//if coupon code is already applied from event page
	useEffect(() => {
		if (ticketDetails) {
			if (eventDetails.event_id && query.selectedCode && !hasMountedOnce.current) {
				const newCouponCode = query.selectedCode;
				setCouponCode(newCouponCode);
				validateCoupon(newCouponCode, query);
				hasMountedOnce.current = true;
			}
		}
	}, [query, eventDetails, ticketDetails]);

	//This function is to check if the coupon applicable ticket is present in selected tickets by the end user
	const checkForValidTicket = applicableTicketsArr => {
		const ticketDetailsArr = selectedTickets?.map(ticket => ticket?.ticket_id).filter(Boolean);
		const commonTicket = _.intersection(applicableTicketsArr, ticketDetailsArr);
		return commonTicket;
	};
	const validateCoupon = async couponCode => {
		if (couponCode.trim() !== "") {
			if (!couponRegex.test(couponCode)) {
				errorToaster(
					"Only alphanumeric characters and special characters @ & # $ ! ( ) - * are allowed"
				);
				return false;
			} else {
				setCouponLoading(true);
				try {
					const res = await validateDiscountCode(
						eventDetails.event_id,
						encodeURIComponent(couponCode)
					);
					const couponDetails = res.data;
					const statusCode = res.status;
					if (res.data.form_rules) {
						setFormRules(res.data.form_rules);
					}
					if (statusCode === 200) {
						const isAccessCode = couponDetails?.tickets?.length > 0 ? true : false;
						if (
							isAccessCode &&
							couponDetails?.tickets?.some(each => each?.team_registration)
						) {
							setHasCouponCode(true);
							setPickedTickets([]);
							setAccessCodeStatus(1); // 1 is "access code applied"
							getCouponDetails(false, couponCode, couponDetails?.tickets);
							if (!isEventPageTeamComp) {
								setCurComp(3);
								successToaster(
									"Access Code applied successfully! Tickets are available under Team Based Registration"
								);
							}
							setCouponLoading(false);
							return;
						} else if (curComp > 0 && curComp < 3 && isAccessCode && !noRemove) {
							const error = !isWaitlist
								? "You are trying to apply an access code, please go back to the ticket selection screen to apply an access code."
								: "Cannot apply access code";
							// errorToaster(error);
							if (!isWaitlist) {
								setHasCouponCode(true);
							}
							setCouponLoading(false);
							return;
						}
						if (!isAccessCode) {
							if (
								couponDetails.availability === 1
								//&& checkForValidTicket(couponDetails.applicable_tickets).length > 0
							) {
								setHasCouponCode(true);
								getCouponDetails(couponDetails, couponCode);
							} else if (couponDetails.availabilty === 2) {
								errorToaster("The coupon code you've entered has been exhausted.");
							} /*else if (checkForValidTicket(couponDetails.applicable_tickets) == 0) {
								errorToaster(
									"The coupon code you've entered is not applicable for the ticket."
								);
							}*/
						} else {
							setHasCouponCode(true);
							setPickedTickets([]);
							setAccessCodeStatus(1); // 1 is "access code applied"
							getCouponDetails(false, couponCode, couponDetails?.tickets);
							if (
								curComp === 3 &&
								!couponDetails?.tickets?.some(each => each?.team_registration)
							) {
								setCurComp(0);
							}
						}
					} else {
						errorToaster("The coupon code you've entered is not available.");
					}
					setCouponLoading(false);
					setDiscountError(false)
				} catch (err) {
					console.log(err);
					setDiscountError(true)
					errorToaster(
						err?.response?.data
							? err.response.data.error
							: "Not able to apply Access/Discount Code at the moment, please try again later"
					);
					setCouponLoading(false);
				}
			}
		} else {
			errorToaster("Please enter a valid Access/Discount Code");
		}
	};

	const resetCoupon = () => {
		const isAccessCode = accessCodeStatus == 1 ? true : false;
		setHasCouponCode(false);
		setCouponCode("");
		isAccessCode && setAccessCodeStatus(2); // 2 is "access code just removed"
		// successToaster("Coupon code removed.");
		removeCoupon(isAccessCode);
	};

	const regex = {
		allowAlphaNumeric: evt => {
			const charCode = String.fromCharCode(evt.which);
			if (!/^[a-z0-9-]+/i.test(charCode)) {
				evt.preventDefault();
			}
			return;
		},
		allowAlphaNumericAndSpecial: evt => {
			//alphanumeric and accpet special characters :- @, &, #, $, !, (, ), *
			const charCode = String.fromCharCode(evt.which);
			if (!couponRegex.test(charCode)) {
				evt.preventDefault();
			}
			return;
		}
	};

	const handleCouponCodeInput = e => {
		regex.allowAlphaNumericAndSpecial(e);
		if (e.charCode === 13) validateCoupon(couponCode);
	};

	const handlePaste = value => {
		if (!couponRegex.test(value)) {
			errorToaster(
				"The Access/Discount Code you are trying to paste contains special characters which are not allowed."
			);
			setCouponCode("");
			setPasted(false);
		}
	};

	useEffect(() => {
		if (pasted && couponCode.trim() !== "") {
			handlePaste(couponCode);
		}
	}, [pasted, couponCode]);

	const containerClass = `coupon-container row mx-0 px-0 pb-3 position-relative ${curComp === 1 && !eventDetails.has_coupons && eventDetails.has_access_codes
		? "custom-background"
		: ""
		}`;


	return (
		<>
			<div className={containerClass}>
				{Object.keys(eventDetails).length !== 0 ? (
					<>
						{(isWidget && query.coupon) === "true" || !isWidget ? (
							curComp === 0 ? (
								<div
									className={`coupon-apply col-sm-12 d-flex flex-column justify-content-around px-3 px-md-0 align-items-start mt-3`}
								>
									<span className="apply-text">
										{eventDetails.has_coupons &&
											!eventDetails.has_access_codes &&
											"Apply Discount Code"}
										{!eventDetails.has_coupons &&
											eventDetails.has_access_codes &&
											"Apply Access Code"}
										{eventDetails.has_coupons &&
											eventDetails.has_access_codes &&
											"Apply Discount / Access Code"}
									</span>
									<div className="w-100 mt-2">
										<TippyIcon content={disabledContent}>
											<div className="position-relative d-inline">
												<input
													className="ps-2 mb-1"
													disabled={hasCouponCode || disabled}
													placeholder="Enter Code"
													value={couponCode}
													inputMode="text"
													autoComplete="off"
													autoCapitalize="characters"
													onChange={(e) => setCouponCode(removeSpace(e.target.value))}
													onKeyPress={e => {
														if (e.key === " ") {
															e.preventDefault();
														}
														handleCouponCodeInput(e)
													}}
													onPaste={e => {
														e.preventDefault();
														setCouponCode(removeSpace(e.clipboardData.getData("text")));
													}}
												></input>
												{hasCouponCode && (
													<div className="coupons-checkmark">
														<Checkmark
															size="16px"
															color="#41c34a"
															strokeWidth="6"
															query={{}}
														/>
													</div>
												)}
											</div>
										</TippyIcon>
										{hasCouponCode ? (
											<>
												{!noRemove && (
													<button
														onClick={resetCoupon}
														disabled={noRemove}
													>
														Remove
													</button>
												)}
											</>
										) : (
											<button
												type="button"
												className="apply-btn"
												onClick={() => validateCoupon(couponCode)}
												disabled={disabled}
											>
												{couponLoading ? (
													<div className="spinner-border small-spinner"></div>
												) : (
													"Apply"
												)}
											</button>
										)}
										{hasCouponCode && (
											<>
												{noRemove && <br />}
												<span className="coupon-code-applied">
													{accessCodeStatus === 1 ? "Access" : "Coupon"}{" "}
													code applied successfully
												</span>
											</>
										)}
									</div>
									{discountError == true && <p style={{ fontSize: "13px", fontWeight: "400", color: "#DC3545" }}>Invalid code. Group discounts are auto-applied.</p>}


								</div>
							) : (eventDetails.has_coupons && eventDetails.has_access_codes) ||
								eventDetails.has_coupons ? (
								<div
									className={`coupon-apply col-sm-12 d-flex flex-column justify-content-around px-3 px-md-0 align-items-start mt-3`}
								>
									<span className="apply-text">
										{eventDetails.has_coupons &&
											!eventDetails.has_access_codes &&
											"Apply Discount Code"}
										{!eventDetails.has_coupons &&
											eventDetails.has_access_codes &&
											"Apply Access Code"}
										{eventDetails.has_coupons &&
											eventDetails.has_access_codes &&
											"Apply Discount / Access Code"}
									</span>
									<div className="w-100 mt-2">
										<TippyIcon content={disabledContent}>
											<div className="position-relative d-inline">
												<input
													className="ps-2 mb-1"
													disabled={hasCouponCode || disabled}
													placeholder="Enter Code"
													value={couponCode}
													inputMode="text"
													autoComplete="off"
													autoCapitalize="characters"
													onChange={(e) => setCouponCode(removeSpace(e.target.value))}
													onKeyPress={e => {
														if (e.key === " ") {
															e.preventDefault();
														}
														handleCouponCodeInput(e)
													}}
													onPaste={e => {
														e.preventDefault();
														setCouponCode(removeSpace(e.clipboardData.getData("text")));
													}}
												></input>
												{hasCouponCode && (
													<div className="coupons-checkmark">
														<Checkmark
															size="16px"
															color="#41c34a"
															strokeWidth="6"
															query={{}}
														/>
													</div>
												)}
											</div>
										</TippyIcon>
										{hasCouponCode ? (
											<>
												{!noRemove && (
													<button
														onClick={resetCoupon}
														disabled={noRemove}
													>
														Remove
													</button>
												)}
											</>
										) : (
											<button
												type="button"
												className="apply-btn"
												onClick={() => validateCoupon(couponCode)}
												disabled={disabled}
											>
												{couponLoading ? (
													<div className="spinner-border small-spinner"></div>
												) : (
													"Apply"
												)}
											</button>
										)}
										{hasCouponCode && (
											<>
												{noRemove && <br />}
												<span className="coupon-code-applied">
													{accessCodeStatus === 1 ? "Access" : "Coupon"}{" "}
													code applied successfully
												</span>
											</>
										)}
									</div>
								</div>
							) : (
								""
							)
						) : (
							""
						)}
					</>
				) : (
					<div className="align-self-center event-header-container event-header-container-image px-0">
						{" "}
						<Loading className="text-center my-5 py-5" />{" "}
					</div>
				)}
			</div>
			<style jsx global>
				{`
					.coupon-container {
						height: auto;
						background: transparent;
						border-radius: 25px;
					}

					.coupons-checkmark {
						position: absolute;
						right: 35px;
						top: 0px;
					}

					input:disabled {
						opacity: 0.8;
					}

					.apply-btn:disabled {
						opacity: 0.4;
						pointer-events: none;
					}

					.apply-btn:disabled:hover {
						color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
						background: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
					}

					.coupon-apply .apply-text {
						font-weight: 500;
						font-size: 16px;
						line-height: 27px;
						color: ${query.secondaryCl ? `#${query.secondaryCl}` : "#572148"};
					}
					.coupon-apply div input {
						background: #fff;
						border-radius: 5px 0px 0px 5px;
						border: none;
						height: 45px;
						width: 70%;
						color: #000;
						font-size: 16px;
					}
					.coupon-apply div input:focus {
						outline: none;
					}
					.coupon-apply div input::placeholder {
						font-style: normal;
						font-weight: normal;
						font-size: 16px;
						color: #999999;
					}
					.coupon-apply div input:focus::placeholder {
						color: #999999;
					}
					.coupon-apply div button {
						height: 45px;
						width: 30%;
						color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
						background: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
						border-radius: 0px 5px 5px 0px;
						border: 2px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
						font-weight: 500;
						font-size: 15px;
						transition: 0.3s all;
					}

					.coupon-apply div button:hover {
						color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
						background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
					}

					.height {
						height: auto;
					}

					.small-spinner {
						width: 1rem;
						height: 1rem;
					}

					.coupon-code-applied {
						font-size: 14px;
						color: ${query.inputErrCl ? `#${query.inputErrCl}` : "#41c34a"};
					}

					@media (max-width: 768px) {
						// .coupon-apply div input {
						//     background: ${query.secondaryBg
						? new TinyColor(`#${query.secondaryBg}`).lighten(30).toString()
						: "#EFE9ED"};
						// }
						.custom-background {
							background: white !important;
							padding-bottom: 0rem !important;
						}
						.coupon-container {
							background: ${query.secondaryBg ? `#${query.secondaryBg}` : "#EFE9ED"};
							border-radius: 10px;
							margin-bottom: 10px;
						}
						.coupons-checkmark {
							top: -8px;
						}
					}
				`}
			</style>
		</>
	);
};

export default React.memo(CouponBox);
